export const getValidEnumValue = <T extends Record<string, string | number>>(
    enumObj: T,
    value: string | number | null | undefined,
): T[keyof T] | undefined => {
    const enumValues = Object.values(enumObj) as Array<T[keyof T]>; // Ensure it's typed as the enum values

    if (typeof value === "string") {
        return enumValues.find((v) => typeof v === "string" && v.toLowerCase() === value.toLowerCase());
    }

    return enumValues.includes(value as T[keyof T]) ? (value as T[keyof T]) : undefined;
};
